import { schema } from 'normalizr';

// --------- GET DATA FOR COMPANIES --------- //

export const company = new schema.Entity(
  'companies',
  {},
  {
    idAttribute: ({ id }) => parseInt(id, 10),
    processStrategy: ({
      id,
      financeId,
      logoPng,
      logo,
      name,
      slug,
      order,
      popular,
    }) => ({
      id: parseInt(id, 10) || 0,
      financeId: parseInt(financeId, 10) || 0,
      logo: !!logoPng && logoPng.length !== 0 ? logoPng : logo,
      slug: slug.toLowerCase(),
      name,
      order: order === 0 ? null : order,
      popular,
    }),
  }
);

export const companies = [company];
